import { IEmailReceptivo } from "../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailReceptivoInterface";

import {
    AtualizarEmailReceptivoService,
    CadastrarEmailReceptivoService,
    DeletarEmailReceptivoService,
    GetEmailReceptivoService,
    ListarEmailReceptivoService,
} from "../../../../Services/Geral/GestaoDeCadastros/EmailConta/EmailReceptivoService";

import { Controller } from "../../../Controller";

export async function CadastrarEmailReceptivoController(
    requestBody: IEmailReceptivo
) {
    return Controller(CadastrarEmailReceptivoService(requestBody));
}

export async function DeletarEmailReceptivoController(
    idEmailReceptivo: number
) {
    return Controller(DeletarEmailReceptivoService(idEmailReceptivo));
}

export async function AtualizarEmailReceptivoController(
    requestBody: IEmailReceptivo
) {
    return Controller(AtualizarEmailReceptivoService(requestBody));
}

export async function ListarEmailReceptivoController() {
    return Controller(ListarEmailReceptivoService());
}

export async function GetEmailReceptivoController(idEmailReceptivo: number) {
    return Controller(GetEmailReceptivoService(idEmailReceptivo));
}
